<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ $t('trainingPlans') }}</h5>
                <p class="mb-0 text-sm">{{ $t('trainingPlansListing') }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <button
                    type="button"
                    class="mb-0 btn bg-gradient-success btn-sm"
                    @click="formularioPlanoTreino()"
                  >
                    +&nbsp; {{ $t('newTrainingPlan') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="!studentOn">
              <span class="mt-5 text-center">
                <h5>{{ $t('selectStudentMessage') }}</h5>
              </span>
            </div>
            <MyTable v-else :data="state.planos" :columns="columns" :itemsPerPage="12">
              <template v-slot:row="{ row }">
                <td class="text-sm pointer" @click="formularioPlanoTreino(row.id)">
                  {{ row.name }} <br />
                  {{ row.cycle_name }}
                </td>
                <td class="text-sm text-center">
                  {{ row.objective }}
                </td>
                <td class="text-sm text-center">
                  {{ $filters.datePtbr(row.initial_date) }} <br />
                  {{ $t('to') }} <br />
                  {{ $filters.datePtbr(row.final_date) }} <br />
                  {{ dayAndWeek(row.initial_date, row.final_date) }}
                </td>
                <td class="text-sm">
                  <div class="float-end d-flex">
                    <div class="me-3">
                      <div class="m-1">
                        <span
                          class="pointer"
                          data-bs-toggle="tooltip"
                          data-bs-original-title="{{ $t('editTrainingPlan') }}"
                          title="{{ $t('editTrainingPlan') }}"
                          data-bs-placement="top"
                          v-tooltip
                          @click="formularioPlanoTreino(row.id)"
                        >
                          <i class="fas fa-pen text-secondary me-2"></i>
                          {{ $t('edit') }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <div class="m-1">
                        <span class="pointer" @click="deletarPlanoTreino(row)">
                          <i class="fas fa-trash text-secondary me-2"></i>
                          {{ $t('delete') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
            </MyTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, watch, computed } from 'vue'
import { useStore } from 'vuex'
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'
import MyTable from '../../../../components/MyTable.vue'
import { useRouter } from 'vue-router'
import moment from 'moment'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    MyTable,
  },
  setup() {
    const router = useRouter()
    const swal = inject('$swal')
    const store = useStore()
    const { t } = useI18n()

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      studentOn.value = store.getters.StudentManager
      if (studentOn.value) {
        listarPlanosTreino()
      }
    })

    let studentOn = ref(false)
    const columns = ref([
      {
        label: t('name'),
        field: 'name',
        sortable: 'name',
      },
      {
        label: t('goal'),
        field: 'objective',
        sortable: '',
      },
      {
        label: t('period'),
        field: 'period',
        sortable: '',
      },
      {
        label: t('actions'),
        field: 'actions',
      },
    ])

    const state = reactive({
      planos: [],
    })

    const listarPlanosTreino = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      planosTreinoRepository
        .PlanosTreinoGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          state.planos = []
          if (response.data.success) {
            state.planos = response.data.data
          }
        })
        .catch((error) => {
          console.error('Erro ao listar planos de treino:', error)
          swal({
            icon: 'error',
            title: 'Erro ao listar planos!',
            text: 'Verifique sua conexão ou tente novamente mais tarde.',
          })
        })
    }

    // Watch para reagir quando o aluno selecionado mudar
    const currentStudent = computed(() => store.getters.StudentManager)
    watch(currentStudent, (newVal) => {
      studentOn.value = newVal
      if (newVal) {
        listarPlanosTreino()
      } else {
        state.planos = []
      }
    })

    function formularioPlanoTreino(id = 0) {
      parseInt(id) !== 0
        ? router.push(`/planos-de-treino/cadastro/${id}`)
        : router.push('/planos-de-treino/cadastro')
    }

    function deletarPlanoTreino(item) {
      swal({
        title: t('areYouSure'),
        text: `${t('doYouWantToDelete')} ${item.name}`,
        showCancelButton: true,
        confirmButtonText: t('yesDelete'),
        cancelButtonText: t('noCancel'),
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deletarPlanoTreinoConfirma(item.id)
        }
      })
    }

    function deletarPlanoTreinoConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      planosTreinoRepository
        .PlanosTreinoDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: t('removed'),
              text: t('contractRemovedSuccessfully'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              listarPlanosTreino()
              setTimeout(() => {
                location.reload()
              }, 100)
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: t('errorDeletingContract'),
            text: error.message,
          })
        })
    }

    function dayAndWeek(initial_date, final_date) {
      let date1 = moment(initial_date)
      let date2 = moment(final_date)
      let numberWeeks = date2.diff(date1, 'weeks')
      let numberDays = date2.diff(date1, 'days')
      return `${numberWeeks} ${t('weeks')} - ${numberDays} ${t('daysNumber')}`
    }

    return {
      state,
      columns,
      deletarPlanoTreino,
      formularioPlanoTreino,
      studentOn,
      dayAndWeek,
    }
  },
}
</script>
